export default __webpack_public_path__ + "static/media/mintd360.87ac1689.svg";